
const EmailModel = {
  canSeeRow: (oldValue: string | boolean | number, newValue: string | boolean | number) => oldValue !== newValue
}

export default EmailModel
